/** Chart Y-axis label semantics shared by the preview's padding and drawing. */

export const CHART_Y_AXIS_DECIMALS_MIN = 0
export const CHART_Y_AXIS_DECIMALS_MAX = 6

export function clampChartYAxisDecimals(value, fallback = 0) {
    const numeric = Number(value)
    if (!Number.isInteger(numeric)) return fallback
    return Math.max(CHART_Y_AXIS_DECIMALS_MIN, Math.min(CHART_Y_AXIS_DECIMALS_MAX, numeric))
}

export function formatChartYAxisLabel(value, decimals) {
    return Number(value).toFixed(clampChartYAxisDecimals(decimals))
}
